import _cloneDeep from 'lodash/cloneDeep';

export default {
  billingCentreResults: (state) => _cloneDeep(state.billingCentreResults),
};
